export { HighlightsCompaniesContent, LogoContent, HighlightsCompanies } from './HighlightsCompanies';
